export default __webpack_public_path__ + "static/media/infobox-system.138d141e.png";